import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function CTA() {
    return (
        <Box
            sx={{
                width: '100%',
                position: 'relative',
                textAlign: 'center',
                color: 'white',
                pt: 4,
                pb: 2,
                backgroundColor: '#1f1f1f'
            }}
        >
            <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
                {/* Small Blue Text */}
                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#1e88e5',
                        fontWeight: 'bold',
                        mb: 2,
                    }}
                >
                    Applications are Closed
                </Typography>

                {/* CTA Headline */}
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: '32px',
                        fontWeight: '600',
                        mb: 4,
                    }}
                >
                    Stay Tuned for Updates
                </Typography>

                {/* Description */}
                <Typography
                    variant="body1"
                    sx={{
                        color: 'rgba(255, 255, 255, 0.85)',
                        mb: 4,
                    }}
                >
                    Thank you for your interest in Cloudathon!
                    Keep an eye out for updates on the 2025 edition.
                    Follow our social media channels for the latest announcements and important details.
                </Typography>

                {/* <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{
                        cursor: 'not-allowed',
                        opacity: 0.7,
                    }}
                >
                    Apply Now
                </Button> */}
            </Container>
        </Box>
    );
}
